<template>
    <div>
        <el-dialog title="角色选择" :visible.sync="visible" width="80%" center>
            <div class="content-data" v-if="0 < roles.length">
                <el-table highlight-current-row :data="roles" border>
                    <el-table-column align="center" type="index"></el-table-column>
                    <el-table-column align="center" label="名称">
                        <template slot-scope="scope">
                            <span>{{scope.row.name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="级别">
                        <template slot-scope="scope">
                            <span>{{scope.row.level}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="!multiple" align="center" fixed="right" label="选择">
                        <template slot-scope="scope">
                            <el-button @click="success(scope.row)" type="primary" size="mini">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="content-data" v-else>
                没有查询到数据
            </div>
            <vue-pager v-bind:datafile="fillData" url="/role/pageRole" v-bind:query="query" ref="pager" v-bind:init="true"></vue-pager>
        </el-dialog>    
    </div>
</template>
<script>
export default {
    data() {
        return {
            roles: [],
            query: {
                userRole:'MANAGER',
                limit:-1
            },
            visible: false,
        }
    },
    props: {
        success: {
            type: Function,
            require: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
    },
    created() {
        var _this = this;
        var userInfo = _this.$common.cache('user_info');
    },
    methods: {
        fillData(_response) {
            var _this = this;
            _this.roles = _response.items;
        },
        submitQuery(_num) {
            var _this = this;
            _this.roles = [];
            _this.$refs.pager.gotoPage(_num);
        },
        openDialog() {
            this.visible = true;
        },
        closeDialog() {
            this.visible = false;
        }
    }
}
</script>
<style scoped>
td {
    text-align: center;
}
.table tr th{
    text-align: center; 
}
</style>